<script>
import { mapGetters } from 'vuex'
import Translatable from '@src/mixins/translatable.js'

import PlanCard from "@components/plan-page/plan-card.vue";

export default {
  components: {
    PlanCard,
  },
  mixins: [
    Translatable
  ],
  computed: {
    ...mapGetters('plan', [
      'pageData',
    ]),
    ...mapGetters('translations', [
      'currentLanguage'
    ]),
    planList() {
      if (this.pageData.content) {
        const list = this.pageData.content[this.currentLanguage].plan[0].title ?
        this.pageData.content[this.currentLanguage].plan : this.pageData.content.en.plan
        
        const images = [this.pageData.plan_web_images, this.pageData.plan_app_images]
        const urls = this.pageData.plan_content
        const buttons = [
          'PLAN_YOUR_TRIP_download_app_btn',
          'PLAN_YOUR_TRIP_see_map_btn',
          'PLAN_YOUR_TRIP_explore_areas_btn',
          'PLAN_YOUR_TRIP_read_brochures_btn',
          'PLAN_YOUR_TRIP_get_transport_info_btn'
        ]

        return list.map((p, index) => {
          return {
            _id: index + 1,
            image: [images[0][index], images[1][index]],
            title: p.title,
            text: p.text,
            buttonText: buttons[index],
            route: urls[index]
          }
        })
      }
      return []
    },
  }
}
</script>

<template>
  <div class="content">
    <PlanCard v-for="step in planList" :key="step._id" :step="step"/>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  display: grid;
  justify-items: center;
  row-gap: 70px;
  grid-template-columns: repeat(1, 1fr);
}

@media only screen and (max-width: $container-width-xs) {
  .content {
    row-gap: 35px;
  }
}
</style>
